<div class="bg-background-light dark:bg-background-dark dark:text-white pt-12 pl-2">
  <!-- Breadcrumbs -->
  <app-breadcrumbs [items]="breadcrumbs" [currentPage]="currentPage"></app-breadcrumbs>

  <!-- Tabs, Search & Dropdowns Row -->
<div
  class="border-b border-gray-200 dark:border-gray-700 mt-1 flex flex-wrap items-center justify-between gap-4"
  *ngIf="!isDetailPage()"
>
  <!-- Tabs -->
  <nav class="flex flex-wrap items-center gap-6" id="tab-nav">
    <a
      *ngFor="let tab of tabs"
      [routerLink]="[tab.id]"
      routerLinkActive="!border-primary !text-primary"
      [routerLinkActiveOptions]="{ exact: true }"
      class="py-4 px-1 border-b-2 text-sm font-bold tracking-wide transition-colors
             border-transparent text-gray-500 dark:text-gray-400
             hover:text-gray-700 dark:hover:text-gray-200
             hover:border-gray-300 dark:hover:border-gray-600"
    >
      {{ tab.label }}
    </a>
  </nav>

  <!-- Search + Dropdowns (only show on non-overview tabs) -->
  <div
    class="flex flex-wrap items-center gap-4"
    *ngIf="!router.url.includes('overview')"
  >
    <app-search-bar
      [placeholder]="searchPlaceholder"
      [resetTrigger]="resetSearch"
      (search)="onSearch($event)"
    ></app-search-bar>

    <app-dropdown
      [label]="'Sort by:'"
      [id]="'sort-by'"
      [selectedValue]="currentSortOrder"
      (valueChanged)="onSortChange($event)"
    >
      <option value="asc">Ascending</option>
      <option value="desc">Descending</option>
    </app-dropdown>

    <app-dropdown
      [label]="'Module:'"
      [id]="'filter-by-module'"
      [selectedValue]="currentModule"
      (valueChanged)="onModuleChange($event)"
    >
      <option *ngFor="let module of modules" [value]="module.value">
        {{ module.name }}
      </option>
    </app-dropdown>
  </div>
</div>


  <!-- Dynamic routed content -->
  <router-outlet></router-outlet>
</div>
